import api from '@/api/api';
import { TMarketCreationResponse } from '../marketCreation.types';
import { TUpdateMatchBody } from './updateMatch.types';
import { isWincore } from '@/features/betApprovals/pages/BetApprovals/tabs/Approvals';
import { getPrefixPath } from '@/common/utils';

const updateMatchURL = `/${getPrefixPath(
  isWincore
)}/trade-manager/market-creation/update-match`;

// Trade Manager - Update Match

export const mutateUpdateMatch = (body: TUpdateMatchBody) =>
  api
    .post<TMarketCreationResponse>(updateMatchURL, body)
    .then((res) => res.data);
